import {GLOBAL__MUTATIONS} from '../mutation-types'

// initial state
const state = {
  isLoading: false,
  error: null,
};

// mutations
const mutations = {
  [GLOBAL__MUTATIONS.SET_IS_LOADING](state) {
    state.isLoading = !state.isLoading;
  },

  [GLOBAL__MUTATIONS.SET_COMMON_ERRORS](state, payload) {
    state.error = payload;
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  mutations,
};
